import { Component, Inject, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { NgForm } from '@angular/forms';
import { ResendVerificationComponent } from './../resend-verification/resend-verification.component';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-verify-mobile',
  templateUrl: './verify-mobile.component.html',
  styleUrls: ['./verify-mobile.component.css']
})
export class VerifyMobileComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private authService: AuthService, private dialog: MatDialog) { }

  ngOnInit() {
  }

  onVerify(form: NgForm) {
    this.authService.verifyMobile(form.value.verificationCode);
  }

  onResendVerification() {
    this.dialog.closeAll();
    this.dialog.open(ResendVerificationComponent);
  }
}
